<template>
  <div>
    <div v-if="form">
      <div>
        <p class="bold">Recruiter Name</p>
        <div v-if="recruiter_names.length > 0">
          <a
            @click="
              form.data.recruiter_fee.fields.recruiter_name.value =
                recruiter_name
            "
            v-for="recruiter_name in recruiter_names"
            class="button is-info recruiter_name"
            :class="{
              'is-outlined':
                form.data.recruiter_fee.fields.recruiter_name.value !=
                recruiter_name,
            }"
          >
            {{ recruiter_name }}
          </a>
        </div>
      </div>
      <div class="vertical_space"></div>
      <div>
        <p class="bold">Fee</p>
        <div class="flex flex_align_center">
          <a
            @click="selectFeePercentage('1')"
            class="button is-info"
            :class="{
              'is-outlined': form.data.recruiter_fee.fields.fee.value != 1,
            }"
            >1%</a
          >
          <div class="horizontal_space"></div>
          <a
            @click="selectFeePercentage('2')"
            class="button is-info"
            :class="{
              'is-outlined': form.data.recruiter_fee.fields.fee.value != 2,
            }"
            >2%</a
          >
          <div class="horizontal_space"></div>
          <a
            @click="selectFeePercentage('3')"
            class="button is-info"
            :class="{
              'is-outlined': form.data.recruiter_fee.fields.fee.value != 3,
            }"
            >3%</a
          >
          <div class="horizontal_space"></div>
          <a
            @click="selectFeePercentage('4')"
            class="button is-info"
            :class="{
              'is-outlined': form.data.recruiter_fee.fields.fee.value != 4,
            }"
            >4%</a
          >
          <div class="horizontal_space"></div>
          <a
            @click="selectFeePercentage('5')"
            class="button is-info"
            :class="{
              'is-outlined': form.data.recruiter_fee.fields.fee.value != 5,
            }"
            >5%</a
          >
          <div class="horizontal_space"></div>
          <p>
            תשלום: <b>{{ $utils.formatSalary(this.getPayment) }}</b> ({{
              this.payload.offer.percentage
            }}% מ- {{ $utils.formatSalary(this.payload.offer.salary) }})
          </p>
        </div>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations, mapActions } from "vuex";
export default {
  name: "recruiter-fee-form",
  props: ["payload"],
  data() {
    return {
      is_loading: false,
      form: undefined,
      recruiter_names: [],
    };
  },
  created() {
    this.getListOfRecruiterNames();
    if (this.payload.is_create) {
      this.setForm({
        id: "",
      });
      return;
    }
    this.$network_utils
      .getRecruiterFee(this.payload.data.id)
      .then((response) => {
        this.setForm(response);
      });
  },
  computed: {
    getPayment() {
      return this.$offers_helper.getPayment(this.payload.offer, false);
    },
  },
  methods: {
    getListOfRecruiterNames() {
      this.$network_utils.getListOfRecruiterNames().then((response) => {
        this.recruiter_names = response.map((i) => i.recruiter_name);
      });
    },
    selectFeePercentage(fee_percentage) {
      this.form.data.recruiter_fee.fields.fee.value = fee_percentage;
    },
    setForm(form_data) {
      this.form = new this.$form({
        recruiter_fee: {
          fields: {
            recruiter_name: {
              value: form_data.recruiter_name,
              has_error: false,
              validations: ["Exists"],
            },
            fee: {
              value: form_data.fee,
              has_error: false,
              validations: ["Number", "Exists"],
            },
            offer_id: {
              value: this.payload.offer.id,
              has_error: false,
              validations: ["Exists"],
            },
          },
          request_details: {
            method: this.payload.is_create ? "post" : "put",
            url: "/recruiter_fees/" + form_data.id,
          },
          is_used: true,
        },
      });
    },
    submit() {
      let response = this.form.mySubmit();
      if (response === false) {
        return;
      }
      this.is_loading = true;
      response.promise
        .then((response) => {
          if (this.payload.callback != undefined) {
            this.payload.callback();
          }
          this.is_loading = false;
          this.removeModal(this.payload);
        })
        .catch(() => {
          this.showToast('ארעה שגיאה')
        });
    },
    ...mapActions('toasts', ['showToast']),
    ...mapMutations("modals", ["removeModal"]),
  },
};
</script>
<style scoped>
.recruiter_name {
  margin-left: 10px;
}
</style>